import { get } from 'lodash';
import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RemoteConfiguration from '../../components/sdk/RemoteConfiguration';
import Device from '../../pages/admin/devices/Device';
import DevicesList from '../../pages/admin/devices/DevicesList';

const Devices = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route
          exact
          path={`${path}/:sptId/sdk/remote_configuration`}
          component={
            (props)=>(
              <RemoteConfiguration configurable={
                {
                  remote_configurable_id: get(props, 'match.params.sptId'),
                  remote_configurable_type: 'Device',
                }
              }/>
            )}
        />
        <Route exact path={`${path}/:sptId`} component={Device}/>
        <Route exact path={`${path}`} component={DevicesList}/>
      </Switch>
    </Suspense>

   );
}

export default Devices;